export default __webpack_public_path__ + "static/media/close popup.0214bd5a.svg";